import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { render } from 'react-dom';
import BaseComponent from 'foundation/base-component';
import configureStore from '../../../sso/store/configure-store';
import { AmplifyClient } from '../../../../project/amplify-client';
import HeaderHero from './HeaderHero';

export default class HeaderHeroComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        this.data = {};

        try {
            AmplifyClient.init();
            this.data = JSON.parse(this.getAttribute(this.refs.data, 'options'));
        } catch (error) {
            console.log(error.message);
        }

        if (!this.data) {
            console.log('No data found');
            return;
        }

        const store = configureStore();

        render(
            <ReduxProvider store={store}>
                <HeaderHero
                    data={this.data} >
                </HeaderHero>
            </ReduxProvider>,
            this.refs.section
        );
    }
}
